import { render, staticRenderFns } from "./DialogTable.vue?vue&type=template&id=29ca1a72&scoped=true"
import script from "./DialogTable.vue?vue&type=script&lang=js"
export * from "./DialogTable.vue?vue&type=script&lang=js"
import style0 from "./DialogTable.vue?vue&type=style&index=0&id=29ca1a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca1a72",
  null
  
)

export default component.exports